import { Link, useLocation } from "react-router-dom";

const tabs = [
    { to: "/admin/users", label: "Team", key: "team" },
    { to: "/admin/reports", label: "Reports", key: "reports" },
];

export default function AdminTabs() {
    const { pathname } = useLocation();
    return (
        <div
            className="tab-pill-group inline-flex mb-6"
            role="tablist"
            data-testid="admin-tabs"
        >
            {tabs.map((t) => {
                const active = pathname === t.to || pathname.startsWith(`${t.to}/`);
                return (
                    <Link
                        key={t.key}
                        to={t.to}
                        className="tab-pill"
                        data-active={active || undefined}
                        data-testid={`admin-tab-${t.key}`}
                        role="tab"
                        aria-selected={active}
                    >
                        {t.label}
                    </Link>
                );
            })}
        </div>
    );
}
